import {
  APP_MANAGED_ROUTES,
  BackgroundInformationModal,
  HsaPage,
  LegalPage,
  EnhancedBenefitsPage,
  AnnualAuthorizationsPage,
} from '@highmark-web/highmark-common';
import { RouteObject } from 'react-router-dom';
import { HomePage, SupportPage } from 'components/lazy-routes.component';
import openHsaImage from 'assets/hsa/open-hsa.svg';
import hsaAccountCreatedImage from 'assets/hsa/hsa-account-created.svg';
import { AboutAllMyHealth } from 'pages/settings/about-allmyhealth.page';

export const StandaloneRoutes: RouteObject[] = [
  { path: `${APP_MANAGED_ROUTES.ABOUT}/*`, element: <AboutAllMyHealth /> },
  {
    path: APP_MANAGED_ROUTES.ANNUAL_AUTHORIZATIONS,
    element: <AnnualAuthorizationsPage />,
  },
  {
    path: `${APP_MANAGED_ROUTES.BACKGROUND_INFORMATION}/*`,
    element: <BackgroundInformationModal />,
  },
  {
    path: APP_MANAGED_ROUTES.HOME,
    element: <HomePage />,
  },
  {
    path: APP_MANAGED_ROUTES.HSA_ENROLLMENT,
    element: (
      <HsaPage
        openHsaImage={openHsaImage}
        hsaAccountCreatedImage={hsaAccountCreatedImage}
      />
    ),
  },
  {
    path: APP_MANAGED_ROUTES.ENHANCED_BENEFITS,
    element: <EnhancedBenefitsPage />,
  },
  { path: `${APP_MANAGED_ROUTES.LEGAL}/*`, element: <LegalPage /> },
  {
    path: APP_MANAGED_ROUTES.SUPPORT,
    element: <SupportPage />,
  },
];
